import type { LayoutType, ViewConfigRow } from '@streamlain/view-config';

import {
  VIEW_COMPONENT_TYPES,
  type ViewComponentType,
} from '../../../constants/view-component-types';
import type { ComponentRegistry } from '../../../services/component-registry';
import type { ComponentCapability } from '../../../types/capability-schema';

const LAYOUT_TO_COMPONENT: Record<LayoutType, ViewComponentType> = {
  list: VIEW_COMPONENT_TYPES.ARTICLE_LIST,
  grid: VIEW_COMPONENT_TYPES.CARD_GRID,
  kanban: VIEW_COMPONENT_TYPES.CARD_GRID,
  dashboard: VIEW_COMPONENT_TYPES.TABLE_VIEW,
};

export function deriveActiveCapabilities(
  row: ViewConfigRow,
  registry: ComponentRegistry
): ComponentCapability[] {
  const ids = new Set<ViewComponentType>();
  ids.add(LAYOUT_TO_COMPONENT[row.layoutType]);
  if (row.form) ids.add(VIEW_COMPONENT_TYPES.FORM_VIEW);
  if (row.search) ids.add(VIEW_COMPONENT_TYPES.SEARCH_BAR);
  if (row.pagination !== 'none') ids.add(VIEW_COMPONENT_TYPES.PAGINATION);
  if (row.tags) ids.add(VIEW_COMPONENT_TYPES.FILTER_BAR);

  const caps: ComponentCapability[] = [];
  for (const id of ids) {
    const component = registry.get(id);
    if (!component) continue;
    const componentCaps = component.capabilities as ComponentCapability[];
    caps.push(...componentCaps);
  }
  return caps;
}
